import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.mwg_effect007')
    if (root) {
        const pinHeight = root.querySelector('.mwg_effect007 .pin-height')
        const container = root.querySelector('.mwg_effect007 .curved-container')
        const circles = root.querySelectorAll('.circle')
        const title = root.querySelector('.title-center')

        ScrollTrigger.create({
            trigger: pinHeight, // Listening to pin-height
            start: 'top top',
            end: 'bottom bottom',
            // markers: true,
            pin: container // The pinned section
        })

        if (title) {
            gsap.to(title, {
                top: '90%',
                yPercent: -90,
                ease: 'none',
                scrollTrigger: {
                    // markers: true,
                    trigger: pinHeight,
                    start: 'top top',
                    end: 'bottom bottom',
                    scrub: true
                    // invalidateOnRefresh: true
                }
            })
        }

        gsap.fromTo(
            circles,
            {
                rotation: 30 // Starting angle
            },
            {
                rotation: -30, // Ending angle
                ease: 'power2.inOut', // Non-linear movement
                stagger: 0.06, // Delay between the start of each circle
                scrollTrigger: {
                    trigger: pinHeight, // Listening to pinHeight
                    start: 'top 80%',
                    end: 'bottom bottom',
                    scrub: true // Animation progresses with scrolling
                    // invalidateOnRefresh: true
                }
            }
        )
        setTimeout(() => {
            ScrollTrigger.refresh()
        }, 1000)
        window.addEventListener('load', () => {
            ScrollTrigger.refresh()
        })
    }
})
